import fr from 'facet-rest';
import { useEffect, useState } from 'react';

export const convertResponseToCollection = (data, args = {}) => new fr.Collection({ data, metaOverride: args.metaOverride });

export default function useCollectionDeprecated(data = {}, args = {}) {
  const { metaOverride = fr.meta() } = args;
  const [collectionData, setCollectionData] = useState(data);

  const [collection, setCollection] = useState(new fr.Collection({ data: collectionData, metaOverride }));
  const [collectionLoading, setCollectionLoading] = useState(false);

  useEffect(() => {
    if (args.createDefault && collection.resources().list().length === 0) {
      setCollection(collection.create({ addToCollection: true }));
    }
  }, [collection]);

  useEffect(() => {
    let coll = convertResponseToCollection(collectionData, args);
    if (args.createDefault && coll.resources().list().length === 0) {
      coll = coll.create({ addToCollection: true });
    }

    setCollection(coll);
  }, [collectionData]);

  const refreshCollection = () => {
    setCollectionLoading(true);
    return (
      collection
        .refresh()
        .then(res => setCollectionData(res.export()))
        .catch(err => Promise.reject(err))
        // Run after the catch so we stop loading after a failure
        .then((c) => {
          setCollectionLoading(false);
          return c;
        })
    );
  };

  return {
    collection,
    collectionLoading,
    refreshCollection,
    setCollectionData,
    convertResponseToCollection,
  };
}
